import React, { useState, useEffect, useCallback } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import { useAdvertisement } from "@redux/advertisement";
import { saveAs } from "file-saver";
import _ from "lodash";
import ADImgDialog from "@modals/ADImgDialog";
import ADFilterDialog from "@modals/ADFilterDialog";
import DashboardMainHeader from "@components/CompDashboard/DashboardMainHeader";
import DashBoardBody from "./DashBoardBody";
import { getStatsDataFromFilterList } from "./Filters";
import { filterMap, conditionCase } from "@assets/utils/check";
import { useMenuDispatch } from "@assets/contexts/MenuContext";

import {START_DATE_STR} from "@assets/constants/dates"

const fthisMonth = new Date();
const fnextMonth = new Date(fthisMonth);
const fnewDate = fnextMonth.setMonth(fthisMonth.getMonth() - 6);
const initialDashboardData = {
  total_ad_list: null, // 광고 총 정보
  advertiser_list: [], // 광고주 총 정보
  ad_list: [], // 광고 총 정보
  img_banners: [], // 배너 정보
  target: {
    advertiser: 0, // 0 : 전체
    ad: 0, // 0 : 전체
    img: null, // null : 선택없음
    imgName: null,
  },
  stats: {
    total: null,
    now: null,
  }, // 차트 총정보
};

const CompDashboard = () => {
  const advertisement = useAdvertisement();
  const [dates, setDates] = useState({
    start: new Date(fnewDate),
    end: new Date(),
  });
  const [check, setCheck] = useState(false);
  const [op, setOp] = useState(false);
  const [popup, setPopup] = useState(false);
  const [openEnd, setOpenEnd] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [filterAD, setFilterAD] = useState(initialDashboardData);
  const value = useMenuDispatch(); // function

  /* 미리 보기 이미지 배너 띄우기 */
  const handlePreviewPop = useCallback(() => {
    const { img } = filterAD.target;
    !img ? alert("이미지 배너를 선택해주세요.") : setPopup((prev) => !prev);
  }, [filterAD.target]);

  /* 광고주 상태 변경 */
  const advertiserFilterChange = (_id) => {
    const newData = filterAD.total_ad_list.filter((data, index) => {
      return data.advertiser_id === _id;
    });
    setFilterAD({
      ...filterAD,
      ad_list: newData,
      img_banners: [],
      target: {
        ...filterAD.target,
        advertiser: _id,
        ad: 0,
        img: null,
      },
    });
  };

  /** 광고 상태 변경 */
  const adFilterChange = (_id) => {
    const newData = filterAD.ad_list.filter((data, index) => {
      return data.ad_id === _id;
    });
    setFilterAD({
      ...filterAD,
      img_banners: _id === 0 ? [] : newData[0].banners,
      target: {
        ...filterAD.target,
        ad: _id,
        img: null,
      },
    });
  };

  /** 이미지 변경 */
  const imgFilterChange = (_id, imgName) => {
    setFilterAD({
      ...filterAD,
      target: {
        ...filterAD.target,
        img: _id,
        imgName: imgName,
      },
    });
  };

  const typeChangeMap = {
    advertiser(_id, imgName) {
      advertiserFilterChange(_id);
    },
    ad(_id, imgName) {
      adFilterChange(_id);
    },
    img(_id, imgName) {
      imgFilterChange(_id, imgName);
    },
  };

  const handleTargetFilterChange = (num, type, imgName = null) => {
    const _id = num;
    typeChangeMap[type](_id, imgName);
  };

  // 필터 상태별 관리 Fnction
  const filterChange = (advertiser, ad, img, filterData) => {
    return filterMap[conditionCase(advertiser, ad, img)](filterData);
  };

  const handleClick = (event) => {
    setOpenDate((previousOpen) => !previousOpen);
    const { advertiser, ad, img } = filterAD.target;
    if (openDate) {
      let filterList = filterChange(advertiser, ad, img, filterAD);
      const dateArray = _.uniq(
        filterList.map((d, i) => {
          return d.date;
        })
      );
      const statsDatas = getStatsDataFromFilterList(filterList); // 최종 그래프 데이터
      const newCntView = newDateCntView(dateArray, filterList); // 날짜별 사용자 View 수 통계 그래프 데이터
      const accCntView = accDateCntView(dateArray, filterList, newCntView); // 누적 뷰수
      const newCntClick = newDateCntClick(dateArray, filterList); // 날짜별 사용자 Click 수 통계 그래프 데이터
      const accCntClick = accDateCntClick(dateArray, filterList, newCntClick); // 누적 클릭수
      statsDatas.total_cnt_view = newCntView;
      statsDatas.total_cnt_click = newCntClick;
      statsDatas.acc_cnt_click = accCntClick;
      statsDatas.acc_cnt_view = accCntView;

      setFilterAD({
        ...filterAD,
        stats: {
          ...filterAD.stats,
          now: statsDatas,
        },
      });
    }
  };

  const handleChecked = (e) => {
    value({ type: "loadingStart" });
    setCheck(e.target.checked);
    if (e.target.checked) {
      setDates({
        ...dates,
        start: new Date(START_DATE_STR),
        end: new Date(),
      });
    } else {
      const thisMonth = new Date();
      const nextMonth = new Date(thisMonth);
      const newDate = nextMonth.setMonth(thisMonth.getMonth() - 6);

      setDates({
        ...dates,
        start: new Date(newDate),
        end: new Date(),
      });
    }
  };

  const handleChangeDate = (newValue, cs = "start") => {
    value({ type: "loadingStart" });
    setDates({
      ...dates,
      [cs]: newValue,
    });
    value({ type: "loadingEnd" });
  };

  const handleExcel = () => {
    let from = dayjs(dates.start).format("YYYY-MM-DD");
    let fromResult = dayjs(dates.start).format("YYMMDD");
    let to = dayjs(dates.end).format("YYYY-MM-DD");
    let toResult = dayjs(dates.end).format("YYMMDD");

    advertisement.excel(from, to, (data, response) => {
      if (response.status === 200) {
        if (data.result.url === null) {
          alert("데이터 정보가 없습니다.");
        } else {
          saveAs(data.result.url, `${fromResult}_${toResult}_daily_count.xlsx`);
        }
      } else {
        alert("에러가 발생했습니다. 새로고침후 사용해주세요.");
      }
    });
  };
  /** 날짜별 사용자 View 수 통계 그래프 데이터 */
  const newDateCntView = (uniqFilter, list) => {
    const returnData = uniqFilter.map((d, i) => {
      let aar = {
        name: null, // 날짜 or 이름
        total: null, // 총합 데이터
      };
      let cnt = 0;
      const filterReuslt = list.filter((dd, ii) => {
        return dd.date === d;
      });
      for (let index = 0; index < filterReuslt.length; index++) {
        cnt = cnt + filterReuslt[index].cnt_view;
      }
      aar.name = filterReuslt[0].date;
      aar.total = cnt;
      return aar;
    });
    return returnData;
  };
  /** 누적 뷰수 체크 */
  const accDateCntView = (uniqFilter, list, newFilter) => {
    const returnData = uniqFilter.map((d, i) => {
      let aar = {
        name: null, // 날짜 or 이름
        total: null, // 총합 데이터
      };
      const totalData = newFilter.map((data) => {
        return data.total;
      });
      const totalArr = totalData.slice(0, i + 1);
      const reducer = (accumulator, curr) => accumulator + curr;
      const filterReuslt = list.filter((dd, ii) => {
        return dd.date === d;
      });
      const sum = totalArr.reduce(reducer);
      aar.total = sum;
      aar.name = filterReuslt[0].date;
      return aar;
    });
    return returnData;
  };
  /** 날짜별 사용자 Click 수 통계 그래프 데이터 */
  const newDateCntClick = (uniqFilter, list) => {
    const returnData = uniqFilter.map((d, i) => {
      let aar = {
        name: null, // 날짜 or 이름
        total: null, // 총합 데이터
      };
      let cnt = 0;
      const test11 = list.filter((dd, ii) => {
        return dd.date === d;
      });
      for (let index = 0; index < test11.length; index++) {
        cnt = cnt + test11[index].cnt_click;
      }
      aar.name = test11[0].date;
      aar.total = cnt;
      return aar;
    });
    return returnData;
  };

  /** 누적 클릭수 체크 */
  const accDateCntClick = (uniqFilter, list, newFilter) => {
    // count점수
    const totalData = newFilter.map((data) => {
      return data.total;
    });
    const returnData = uniqFilter.map((d, i) => {
      let aar = {
        name: null, // 날짜 or 이름
        total: null, // 총합 데이터
      };
      var totalArr = totalData.slice(0, i + 1);
      const reducer = (accumulator, curr) => accumulator + curr;
      const test11 = list.filter((dd, ii) => {
        return dd.date === d;
      });
      var sum = totalArr.reduce(reducer);
      aar.total = sum;
      aar.name = test11[0].date;
      return aar;
    });
    return returnData;
  };

  // advertiser on
  const statCheck = (totalDatas) => {
    value({ type: "loadingStart" });
    const { advertiser, ad } = filterAD.target;
    let filterList = totalDatas;
    if (advertiser !== 0) {
      filterList = totalDatas.filter((data) =>
        ad === 0
          ? data.advertiser_id === advertiser
          : data.advertiser_id === advertiser && data.ad_id === ad
      );
    }
    const dateArray = _.uniq(
      filterList.map((d, i) => {
        return d.date;
      })
    );
    const statsDatas = getStatsDataFromFilterList(filterList); // 최종 그래프 데이터
    const newCntView = newDateCntView(dateArray, filterList); // 날짜별 사용자 View 수 통계 그래프 데이터
    const accCntView = accDateCntView(dateArray, filterList, newCntView); // 누적 뷰수
    const newCntClick = newDateCntClick(dateArray, filterList); // 날짜별 사용자 Click 수 통계 그래프 데이터
    const accCntClick = accDateCntClick(dateArray, filterList, newCntClick); // 누적 클릭수
    statsDatas.total_cnt_view = newCntView;
    statsDatas.total_cnt_click = newCntClick;
    statsDatas.acc_cnt_click = accCntClick;
    statsDatas.acc_cnt_view = accCntView;

    setFilterAD({
      ...filterAD,
      stats: {
        ...filterAD.stats,
        total: totalDatas,
        now: statsDatas,
      },
    });
    value({ type: "loadingEnd" });
  };

  const advertiserCheck = () => {
    const filterData = filterAD.advertiser_list.filter(
      (data) => data[0].advertiser_id === filterAD.target.advertiser
    );
    return filterData[0][0].advertiser_name;
  };

  const adCheck = () => {
    const filterData = filterAD.ad_list.filter(
      (data) => data.ad_id === filterAD.target.ad
    );
    return filterData[0].title;
  };

  useEffect(() => {
    value({ type: "loadingStart" });
    advertisement.list((data, response) => {
      if (response.status === 200 && data.error === undefined) {
        const totalData = data.result;
        const totalAdvertiser = _.uniq(
          data.result.map((d, i) => {
            return d.advertiser_id;
          })
        );
        const newData = totalAdvertiser.map((d, i) => {
          return data.result.filter((dd, ii) => {
            return dd.advertiser_id === d;
          });
        });
        setFilterAD({
          ...filterAD,
          total_ad_list: totalData,
          advertiser_list: newData, // 광고주 총 정보
          ad_list: [], // 광고 총 정보
          img_banners: [], // 배너 정보
          target: {
            ...filterAD.target,
          },
        });
      } else {
        alert("에러가 발생하였습니다.");
        value({ type: "loadingEnd" });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Grid container direction="column">
        <Typography
          textAlign="left"
          variant="h1"
          component="div"
          fontWeight={500}
          sx={{ mb: 3 }}
        >
          대시보드
        </Typography>
        <DashboardMainHeader
          filterAD={filterAD}
          check={check}
          handleExcel={handleExcel}
          onPopup={handlePreviewPop}
          handleClick={handleClick}
          adCheck={adCheck}
          advertiserCheck={advertiserCheck}
          handleTargetFilterChange={handleTargetFilterChange}
          handleChecked={handleChecked}
          dates={dates}
          op={op}
          setOp={setOp}
          handleChangeDate={handleChangeDate}
          openEnd={openEnd}
          setOpenEnd={setOpenEnd}
        />
        {filterAD.total_ad_list !== null && (
          <DashBoardBody
            dates={dates}
            statCheck={statCheck}
            filterAD={filterAD}
          />
        )}
        <ADImgDialog
          open={popup}
          filterAD={filterAD}
          onClose={handlePreviewPop}
        />
        <ADFilterDialog
          open={openDate}
          onClose={handleClick}
          onChange={handleTargetFilterChange}
          adData={filterAD}
          advertiserCheck={advertiserCheck}
          adCheck={adCheck}
        />
      </Grid>
    </>
  );
};

export default CompDashboard;
